import { Injectable } from '@angular/core';
import { Employee } from '../shared/models/employee';
import { startOfWeek, lastDayOfWeek, sub, startOfMonth, lastDayOfMonth, startOfQuarter, lastDayOfQuarter, format, isValid, parse, add, isBefore, isSameDay, isAfter, differenceInHours } from 'date-fns';
import { EmployeeBase } from '../shared/models/employee-base';
import { environment } from 'src/environments/environment';
import { EntityCategory } from '../shared/models/entity-category';
import { RosterCodes } from '../shared/models/roster-codes';
import { drop } from 'lodash';
import { IRosterEmployeeViewModel } from '../shared/models/roster/roster-employee-view-model';

@Injectable({
  providedIn: 'root'
})
export class PpsUtilityService {

  constructor() { }

  // toJsDate(date: NgbDate): Date{
  //   if (date === null){
  //     return null;
  //   }

  //   return new Date(date.year, date.month - 1, date.day);
  // }

  // toNgbDate(date: Date): NgbDate{
  //   if (date === null){
  //     return null;
  //   }

  //   let ngbDate = NgbDate.from({
  //     year: date.getFullYear(),
  //     month: date.getMonth() + 1,
  //     day: date.getDate()
  //   });

  //   return ngbDate;
  // }

  sortByDate(data: any[], dateField: string): any[]{
    return data.sort((a: any, b: any) => {
      return this.getTime(a[dateField]) - this.getTime(b[dateField]);
    });
  }

  getEmployeeName(employee: EmployeeBase|IRosterEmployeeViewModel, compact: boolean = false): string{
    if (!employee){
      return "";
    }

    let temp = [], temp2 = [];

    if (employee.firstName){
      temp2.push(employee.firstName);
    }

    if (employee.middleName){
      temp2.push(employee.middleName)
    }

    if (employee.lastName){
      temp.push(employee.lastName);
    }

    if (temp2.length > 0){
      temp.push(temp2.join(" "));
    }

    return compact ? temp.join(",") : temp.join(", ");
  }

  getDateRange(key: string): {from:Date, to:Date}{
    return this.getDateRanges()[key];
  }

  getDateRanges(){
    let today = new Date();
    let option: any = {weekStartsOn: 1};

    let dateRange = {
      "today": {title:"Today", from: today, to: today},
      "tomorrow": {title:"Tomorrow", from: add(today, {days: 1}), to: add(today, {days: 1})},
      "yesterday": {title:"Yesterday", from: sub(today, {days: 1}), to: sub(today, {days: 1})},
      "this-week": {title:"This Week", from: startOfWeek(today, option), to: lastDayOfWeek(today, option)},
      "last-week": {title:"Last Week", from: sub(startOfWeek(today, option), {weeks: 1}), to: lastDayOfWeek(sub(today, {weeks: 1}), option)},
      "this-month": {title:"This Month", from: startOfMonth(today), to: lastDayOfMonth(today)},
      "last-month": {title:"Last Month", from: sub(startOfMonth(today), {months: 1}), to: lastDayOfMonth(sub(today, {months: 1}))},
      "this-quarter": {title:"This Quarter", from: startOfQuarter(today), to: lastDayOfQuarter(today)},
      "last-quarter": {title:"Last Quarter", from: sub(startOfQuarter(today), {months: 3}), to: lastDayOfQuarter(sub(today, {months: 3}))},
      "last-30-days":{title:"Last 30 Days", from: sub(today, {days:30}), to: today},
      "last-60-days":{title:"Last 60 Days", from: sub(today, {days:60}), to: today},
      "last-90-days":{title:"Last 90 Days", from: sub(today, {days:90}), to: today},
      "last-120-days":{title:"Last 120 Days", from: sub(today, {days:120}), to: today},

      "next-week": {title:"Next Week", from: add(startOfWeek(today, option), {weeks:1}), to: lastDayOfWeek(add(today, {weeks:1}), option)},
      "next-month": {title:"Next Month", from: add(startOfMonth(today), {months: 1}), to: lastDayOfMonth(add(today, {months: 1}))},
      "next-quarter": {title:"Next Quarter", from: add(startOfQuarter(today), {months: 3}), to: lastDayOfQuarter(add(today, {months: 3}))},
      "next-30-days":{title:"Next 30 Days", to: add(today, {days:30}), from: today},
      "next-60-days":{title:"Next 60 Days", to: add(today, {days:60}), from: today},
      "next-90-days":{title:"Next 90 Days", to: add(today, {days:90}), from: today},
      "next-120-days":{title:"Next 120 Days", to: add(today, {days:120}), from: today}
    };

    return dateRange;
  }

  formatPercentage(val: number): string{
    if (val === null){
      return "";
    }

    let str = (val || 0).toFixed(0);
    return str + "%";
  }

  formatCurrency(val: number): string{
    let str = (val || 0).toFixed(2);
    return "$" + str.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  formatNumber(val: number, numberOfDecimal?:number ): string{
    numberOfDecimal = numberOfDecimal | 0;
    let str = (val || 0).toFixed(numberOfDecimal);
    return str.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  getNumericCellStyle(style){
    style = style || {textAlign: 'right'};
    if (!style.hasOwnProperty("textAlign")){
      style.textAlign = "right";
    }

    return style;
  }

  getComputedCellStyle(style){
    style = style || {fontStyle: 'italic'};
    if (!style.hasOwnProperty("fontStyle")){
      style.fontStyle = "italic";
    }

    return style;
  }

  padNumber(num: number, size: number, pad: string) {
    var s = String(num);
    while (s.length < (size || 2)) {s = pad + s;}
    return s;
  }

  getStates(){
    return [
      {"code": "ACT", "name": "Australian Capital Territory	"},
      {"code": "NSW", "name": "New South Wales"},
      {"code": "NT", "name": "Northern Territory"},
      {"code": "QLD", "name": "Queensland"},
      {"code": "SA", "name": "South Australia	"},
      {"code": "TAS", "name": "Tasmania"},
      {"code": "VIC", "name": "Victoria"},
      {"code": "WA", "name": "Western Australia	"}
    ];
  }

  getGstRate(): number{
    return 1.1;
  }

  getDate(date: string): Date{
    return parse(date, "dd/MM/yyyy", new Date());
  }

  getDateString(date:Date): string{
    if (!date){
      return "";
    }
    
    return format(date, "dd/MM/yyyy");
  }

  getDateTimeString(date:Date): string{
    if (!date){
      return "";
    }
    
    return format(date, "dd/MM/yyyy HH:mm:ss");
  }
  
  getEntityCategoryName(categoryId: EntityCategory){
    switch(categoryId){
      case EntityCategory.Area: 
        return "Area";
      case EntityCategory.ClientEngineer:
        return "Client Engineer";
      case EntityCategory.InstallationProgress:
        return "Installation Progress";
      case EntityCategory.JobType:
        return "Job Type";
      case EntityCategory.ProjectStatus:
        return "Project Status";
      case EntityCategory.WorkGroup:
        return "Work Group";
      case EntityCategory.WorkShift:
        return "Work Shift";
    }
    return "Unknown";
  }

  getEntityCategory(category: string): EntityCategory{
    category = category ? category.toLowerCase().replace(" ", "") : "";
    switch(category){
      case "area": 
        return EntityCategory.Area;
      case "clientengineer":
        return EntityCategory.ClientEngineer;
      case "installationprogress":
        return EntityCategory.InstallationProgress;
      case "jobtype":
        return EntityCategory.JobType;
      case "projectstatus":
        return EntityCategory.ProjectStatus;
      case "workgroup":
        return EntityCategory.WorkGroup; 
      case "workshift":
        return EntityCategory.WorkShift;
    }

    return EntityCategory.Unknown;
  }


  isSupervisorGroup(name: string): boolean{
    //return name === "Project Management" || name === "Supervisors";
    return true;
  }

  get isLocalOrDevelopment(): boolean{
    return environment.name === "local" ||  environment.name === "development";
  }

  get isTest(): boolean{
    return environment.name === "test";
  }

  get isProduction(): boolean{
    return environment.name === "production";
  }

  filterDateComparator(d1: Date, date2: string){
    let dateFormat: string = "dd/MM/yyyy"
    let today = new Date(1900,1,1);
    date2 = date2 || "1/1/1900";
    let dateParts = date2.split(" ");
    if (dateParts.length >= 1){
      date2 = dateParts[0];
    }

    let d2 = parse(date2, dateFormat, today);
    
    if ( isBefore(d1, d2) ){
      return 1;
    }

    if ( isAfter(d1, d2)){
      return -1;
    }

    return 0;
  }

  dateComparator(date1: string, date2: string, dateFormat: string = "dd/MM/yyyy"){
    let today = new Date(1900,1,1);
    date1 = date1 || "1/1/1900";
    date2 = date2 || "1/1/1900";

    let d1 = parse(date1, dateFormat, today);
    let d2 = parse(date2, dateFormat, today);
    
    if ( isBefore(d1, d2) ){
      return -1;
    }

    if ( isAfter(d1, d2)){
      return 1;
    }

    return 0;
  }

  dateTimeComparator(date1: string, date2: string, dateFormat: string = "dd/MM/yyyy hh:mm a"){
    let today = new Date(1900,1,1,0,0,0);
    date1 = date1 || "1/1/1900 12:00 AM";
    date2 = date2 || "1/1/1900 12:00 AM";

    let d1 = parse(date1, dateFormat, today);
    let d2 = parse(date2, dateFormat, today);
    
    if ( isBefore(d1, d2) ){
      return -1;
    }

    if ( isAfter(d1, d2)){
      return 1;
    }

    return 0;
  }

  getNewName(prefix: string, suffix: number, entities: any[], predict){
    let name = prefix + (suffix === 0 ? "" : " " + suffix);
    let index = entities.findIndex(c => predict(c, name));
    if (index !== -1){
      return this.getNewName(prefix, suffix + 1, entities, predict);
    }

    return name;
  }

  private getTime(date?: Date) {
    return date ? date.getTime() : 0;
  }

  daysDiff(from: Date, to: Date): number{
    // Due to day time saving, when calculate hours difference in March, one hour will be lost. 
    // To avoid that, adding 23 hours to the hours diff
    var hoursDiff = differenceInHours(to, from) + 23;
    return Math.floor(hoursDiff/24);
  }

  deepCopy(obj) {
    var copy;

    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
        copy = [];
        for (var i = 0, len = obj.length; i < len; i++) {
            copy[i] = this.deepCopy(obj[i]);
        }
        return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
        copy = {};
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) copy[attr] = this.deepCopy(obj[attr]);
        }
        return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
  }  

  isNumeric(n): boolean{
    return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
  }

  isDayNightCode(rosterCode: number|string): boolean{
    if (this.isNumeric(rosterCode)){
      return rosterCode === RosterCodes.Day || rosterCode === RosterCodes.Night;
    }

    rosterCode = (rosterCode + "").toLowerCase();
    return rosterCode === "day" || rosterCode === "night";    
  }

  isReddish(colorStr){
    var rgb = this.hexToRgb(colorStr);
    if (rgb.r > 100 && rgb.r > rgb.g * 2 && rgb.r > rgb.b * 2 ){
      return true;
    }

    return false;
  }

  private hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }  

  public getDateOnly(dt:Date): Date{
    return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
  }

  sortAsc(obj1: any, obj2: any, propName: string){
    return this.sortHelper(obj1, obj2, propName, true);
  }

  sortDesc(obj1: any, obj2: any, propName: string){
    return this.sortHelper(obj1, obj2, propName, false);
  }

  private sortHelper(obj1: any, obj2: any, propName: string, asc: boolean){
    if (obj1[propName] === obj2[propName]){
      return 0;
    }

    if (obj1[propName] > obj2[propName]){
      return asc ? 1 : -1;
    }

    return asc ? -1 : 1;
  }
}
